/* ARIA tabs for Smartap sections (the WAI-ARIA Authoring Practices tabs pattern, automatic
   activation). The markup ships every panel visible, without tab roles, and the tab list hidden,
   so with no script the content is plain and stacked; this reveals the list, gives the panels
   their tabpanel role and shows one panel at a time.
   Arrow keys move between tabs, Home and End jump to the ends. */
if (!customElements.get('st-tabs')) {
  customElements.define(
    'st-tabs',
    class extends HTMLElement {
      connectedCallback() {
        const list = this.querySelector('[data-st-tablist]');
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        if (!list || this.tabs.length < 2) return;
        list.hidden = false;
        this.tabs.forEach((tab) => {
          const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);
          if (!panel) return;
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
        });
        this.classList.add('is-tabbed');
        const start = Math.max(0, this.tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true'));
        this.select(start, false);
        list.addEventListener('click', (e) => {
          // No programmatic focus on a pointer choice: Safari does not focus a clicked button, and
          // moving focus there drew the keyboard ring on a mouse click (Paulius, 2026-10-09).
          const tab = e.target.closest('[role="tab"]');
          if (tab) this.select(this.tabs.indexOf(tab), false);
        });
        list.addEventListener('keydown', (e) => {
          const i = this.tabs.indexOf(document.activeElement);
          if (i < 0) return;
          const n = this.tabs.length;
          const next = { ArrowRight: (i + 1) % n, ArrowDown: (i + 1) % n, ArrowLeft: (i - 1 + n) % n, ArrowUp: (i - 1 + n) % n, Home: 0, End: n - 1 }[e.key];
          if (next === undefined) return;
          e.preventDefault();
          this.select(next, true);
        });
      }

      select(index, focus) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute('aria-selected', String(on));
          tab.tabIndex = on ? 0 : -1;
          const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);
          if (panel) panel.hidden = !on;
        });
        if (focus) this.tabs[index].focus();
      }
    }
  );
}
